// src/layouts/LandingLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';
import TopHeader from '../components/topHeader';
import Footer from '../components/footer';
const LandingLayout = () => {
  return (
    <>
       <TopHeader />   
       <Header />
       <Outlet />
       <Footer />
     
    </>
  );
};

export default LandingLayout;
